// extracted by mini-css-extract-plugin
module.exports = {"mecha":"index-mecha-fkjxl","btnDetail":"index-btnDetail-2HaLX","active":"index-active-32Dey"};